<script setup lang="ts">
import { vMaska } from "maska/vue";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
// 日付選択FormInput
dayjs.extend(customParseFormat);
interface Props {
  modelValue?: string;
  label?: string;
  label2?: string;
  format?: "date" | "ym";
  placeholder?: string;
  required?: boolean;
  id?: string;
  alert?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  label: "",
  label2: "",
  format: "date",
  alert: "正しい日付を入力してください",
  placeholder: "日付を入力",
  require: false,
});

const emit = defineEmits<{
  "update:modelValue": [modelValue: string];
}>();

if (props.required) {
  useValidatable();
}

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const isError = ref(false);

function validate() {
  // 必須でなくて値がないとき
  if (!props.required && !props.modelValue) {
    isError.value = false;
    return true;
  }

  // (必須ではないが値はある || 必須で値がない || 必須で値がある) && テストに失敗
  if (
    !dayjs(
      localValue.value,
      `YYYY-MM${props.format == "date" ? "-DD" : ""}`,
      true,
    ).isValid()
  ) {
    isError.value = true;
    return false;
  }

  // テストに合格
  isError.value = false;
  return true;
}

watchDebounced(
  () => localValue.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (localValue.value) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({ validate });
</script>

<template>
  <div ref="el" class="w-full tablet:max-w-[50%] relative pb-6">
    <FormInputLabel :label="label" :label2="label2" :id="id" />
    <div class="flex items-center relative">
      <MInput
        v-maska
        :data-maska="`####-##${format == 'date' ? '-##' : ''}`"
        v-model="localValue"
        class="w-full block rounded p-2"
        :id="id"
        type="text"
        inputmode="numeric"
        :placeholder="placeholder"
        :color="isError ? 'error' : 'normal'"
      />
    </div>

    <FormAlert
      type="error"
      class="flex items-center absolute bottom-0"
      v-if="isError"
    >
      <Icon class="mr-1 text-sm" size="18" name="mdi:alert-circle" />
      <span>{{ alert }}</span>
    </FormAlert>
  </div>
</template>
